import React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

const useAuth = () => {
  const users = localStorage.getItem("users");
  if (users) {
    return true;
  } else {
    return false;
  }
};

const ProtectedRoutes = (props) => {
  const auth = useAuth();
  const location = useLocation();

  return auth ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
